export const SWITCH_ID__BLOCK = 'LC_BLOCK';
export const SWITCH_ID__DISTRICT = 'LC_DISTRICT';
export const SWITCH_ID__MUNICIPALITY = 'LC_MUNICIPALITY';
export const SWITCH_ID__CUSTOM = 'LC_CUSTOM';
export const SWITCH_ID__COUNTY = 'LC_COUNTY';
export const SWITCH_ID__GOVERNMENT_DISTRICT = 'LC_GOV_DISTRICT';
export const SWITCH_ID__FEDERAL_STATE = 'LC_FEDERAL_STATE';
export const SWITCH_ID__BKG_RASTER = 'LC_BKG_RASTER';
export const SWITCH_ID__HEAT_DENSITY_STREETS = 'LC_HEAT_DENSITY_STREETS';
export const SWITCH_ID__AGGREGATION_LEVEL_CLIENT_DATA =
  'LC_AGGREGATION_LEVEL_CLIENT_DATA';

export const SWITCH_ID__PV_FREE = 'LC_PV_FREE';
export const SWITCH_ID__PV_ROOF = 'LC_PV_ROOF';
export const SWITCH_ID__SOLAR_THERMAL_FREE = 'LC_SOLAR_THERMAL_FREE';
export const SWITCH_ID__SOLAR_THERMAL_ROOF = 'LC_SOLAR_THERMAL_ROOF';
export const SWITCH_ID__BUILDING_HEAT = 'LC_BUILDING_HEAT';
export const SWITCH_ID__BLOCK_HEAT = 'LC_BLOCK_HEAT';
export const SWITCH_ID__CUSTOM_HEAT = 'LC_CUSTOM_HEAT';
export const SWITCH_ID__WASTE_HEAT = 'LC_WASTE_HEAT';
export const SWITCH_ID__BIOMASS = 'LC_BIOMASS';
export const SWITCH_ID__WIND = 'LC_WIND';
export const SWITCH_ID__NETWORK_CLUSTER = 'LC_POT_NETWORK_CLUSTER';
export const SWITCH_ID__BUILDING_NETWORK = 'LC_POT_BUILDING_NETWORK';
export const SWITCH_ID__DISTRIBUTION_NETWORK = 'LC_POT_DISTRIBUTION_NETWORK';

export const SWITCH_ID__HEATNETWORK_DOMINANCE_BLOCK =
  'LC_SZ_HEATNETWORK_DOMINANCE_BLOCK';
export const SWITCH_ID__HYDROGEN_DOMINANCE_BLOCK =
  'LC_SZ_HYDROGEN_DOMINANCE_BLOCK';
export const SWITCH_ID__DECENTRALIZED_DOMINANCE_BLOCK =
  'LC_SZ_DECENTRALIZED_DOMINANCE_BLOCK';
export const SWITCH_ID__SUMMARY_DOMINANCE_BLOCK =
  'LC_SZ_SUMMARY_DOMINANCE_BLOCK';
export const SWITCH_ID__HEATNETWORK_DOMINANCE_CUSTOM_AGGREGATION =
  'LC_SZ_HEATNETWORK_DOMINANCE_CUSTOM_AGGREGATION';
export const SWITCH_ID__HYDROGEN_DOMINANCE_CUSTOM_AGGREGATION =
  'LC_SZ_HYDROGEN_DOMINANCE_CUSTOM_AGGREGATION';
export const SWITCH_ID__DECENTRALIZED_DOMINANCE_CUSTOM_AGGREGATION =
  'LC_SZ_DECENTRALIZED_DOMINANCE_CUSTOM_AGGREGATION';
export const SWITCH_ID__SUMMARY_DOMINANCE_CUSTOM_AGGREGATION =
  'LC_SZ_SUMMARY_DOMINANCE_CUSTOM_AGGREGATION';

export const DOMINANCE_SWITCH_IDS = [
  SWITCH_ID__HEATNETWORK_DOMINANCE_BLOCK,
  SWITCH_ID__DECENTRALIZED_DOMINANCE_BLOCK,
  SWITCH_ID__HYDROGEN_DOMINANCE_BLOCK,
  SWITCH_ID__SUMMARY_DOMINANCE_BLOCK,
  SWITCH_ID__HEATNETWORK_DOMINANCE_CUSTOM_AGGREGATION,
  SWITCH_ID__DECENTRALIZED_DOMINANCE_CUSTOM_AGGREGATION,
  SWITCH_ID__HYDROGEN_DOMINANCE_CUSTOM_AGGREGATION,
  SWITCH_ID__SUMMARY_DOMINANCE_CUSTOM_AGGREGATION,
];

export const REFURBISHMENT_POTENTIAL_SWITCH_IDS = [
  SWITCH_ID__BUILDING_HEAT,
  SWITCH_ID__BLOCK_HEAT,
  SWITCH_ID__CUSTOM_HEAT,
];

export const AGGREGATION_SWITCH_IDS = [
  SWITCH_ID__BLOCK,
  SWITCH_ID__COUNTY,
  SWITCH_ID__CUSTOM,
  SWITCH_ID__DISTRICT,
  SWITCH_ID__GOVERNMENT_DISTRICT,
  SWITCH_ID__BKG_RASTER,
  SWITCH_ID__HEAT_DENSITY_STREETS,
  SWITCH_ID__MUNICIPALITY,
  SWITCH_ID__AGGREGATION_LEVEL_CLIENT_DATA,
  SWITCH_ID__FEDERAL_STATE,
];
